import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types'
import { decodeBase64, encodeBase64 } from '../../utils';
import {
  Grid,
  Button,
  Picklist
} from '../'

const getTargetBankaccountNameFromId = (id, withdrawableTargetBankaccounts) =>
  Object.entries(withdrawableTargetBankaccounts).find(
    ([key, valueObj]) => valueObj.id === decodeBase64(id)
  )[0];

export class BankUpdateForm extends Component {
  static propTypes = {
    targetBankaccountId: PropTypes.string,
    withdrawableTargetBankaccounts: PropTypes.object.isRequired, // JSON.parsed in parent component
  };

  state = {
    target: getTargetBankaccountNameFromId(
      this.props.targetBankaccountId,
      this.props.withdrawableTargetBankaccounts
    ),
  };

  handleTargetChange = (targetName) => {
    this.setState({ target: targetName });
  };

  getTargetBankaccountId = (name) => {
    return encodeBase64(
      this.props.withdrawableTargetBankaccounts[name].id,
      'IdentityBankAccountNode'
    );
  };

  save = () => {
    let targetBankaccountId = this.getTargetBankaccountId(this.state.target);
    this.props.onSaveClick(targetBankaccountId);
  };

  render() {
    const { withdrawableTargetBankaccounts, onCancelClick } = this.props;
    const { target } = this.state;
    const targetOptions = [...Object.keys(withdrawableTargetBankaccounts)];

    return (
      <Fragment>
        <Grid
          items={[
            <div className="slds-size_1-of-3">Towards:</div>,
            <Picklist
              id="target"
              options={targetOptions}
              value={targetOptions.indexOf(target) > -1 ? target : null}
              onChange={this.handleTargetChange}
              closeDropdownOnSelect={true}
              className="slds-size_2-of-3 slds-m-bottom_medium"
            />,
          ]}
          inheritItemAsIs={true}
        />
        <div className="slds-text-align_center slds-p-top_large">
          <Button minWidth={150} onClick={onCancelClick}>
            Cancel
          </Button>
          <Button
            type="brand"
            minWidth={150}
            disabled={!target}
            onClick={this.save}
          >
            Save changes
          </Button>
        </div>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/withdrawal-bank-change-modal/BankUpdateForm.js